import React, {
  Component
} from 'react'

import './TeamMembers.css'

import ChrishaPic from './../../../img/team-members/Chrisha.jpg';
import AdaPic from './../../../img/team-members/Ada.jpg';
import SimonPic from './../../../img/team-members/Simon.jpg';
import ElisabethPic from './../../../img/team-members/Elisabeth.jpg';
import MyaPic from './../../../img/team-members/mya_spoelstra.jpg';
import MubashirPic from './../../../img/team-members/Mubashir.jpg';
import TylerPic from './../../../img/team-members/Tyler.jpg';
import AndrewPic from './../../../img/team-members/Andrew.jpg';
import AidanPic from './../../../img/team-members/Aidan.jpg';
import BoscoPic from './../../../img/team-members/Bosco.jpg';
import CadenPic from './../../../img/team-members/Caden.jpg';
import ColePic from './../../../img/team-members/Cole.jpg';
import FrancescaPic from './../../../img/team-members/Francesca.jpg';
import JinPic from './../../../img/team-members/Jin.jpg';
import JordanPic from './../../../img/team-members/Jordan.jpg';
import KevinPic from './../../../img/team-members/Kevin.jpg';
import KirillPic from './../../../img/team-members/Kirill.jpg';
import LaaibahPic from './../../../img/team-members/Laaibah.jpg';
import ManushPic from './../../../img/team-members/Manush.jpg';
import MarioPic from './../../../img/team-members/Mario.jpg';
import NickPic from './../../../img/team-members/Nick.jpg';
import NoahPic from './../../../img/team-members/Noah.jpg';
import QuinPic from './../../../img/team-members/Quin.jpg';
import RemyPic from './../../../img/team-members/Remy.jpg';
import SophiaPic from './../../../img/team-members/Sophia.jpg';
import SpencerPic from './../../../img/team-members/Spencer.jpg';




export class TeamMembers extends Component {
  constructor() {
    super()
    this.state = {
      members: [{
          name: 'Ada Wu',
          photo: AdaPic,
          position: 'Team Captain',
          linkedin: 'https://www.linkedin.com/in/adawu1/'
        },
        {
          name: 'Caden Chan',
          photo: CadenPic,
          position: 'Electrical Co-Director',
          linkedin: "https://www.linkedin.com/in/cadenchan22/"
        },
        {
          name: 'Elisabeth Mark',
          photo: ElisabethPic,
          position: 'Electrical Co-Director',
          linkedin: "https://www.linkedin.com/in/elisabeth-mark/"
        },  
        {
          name: 'Simon Armbruster',
          photo: SimonPic,
          position: 'Mechanical Co-Director',
          linkedin: "https://www.linkedin.com/in/simon-armbruster-a421b2261/"
        },
        {
          name: 'Tyler Lounsbury',
          photo: TylerPic,
          position: 'Mechanical Co-Director',
          linkedin: "https://www.linkedin.com/in/tylerlounsbury/"
        },
        {
          name: 'Jordan Atkins',
          photo: JordanPic,
          position: 'Aerodynamics Co-Lead',
          linkedin: "https://www.linkedin.com/in/jordanmatkins/"
        },
        {
          name: 'Kirill Dariy',
          photo: KirillPic,
          position: 'Aerodynamics Co-Lead',
          linkedin: "https://www.linkedin.com/in/kirilldariy/"
        },
        {
          name: 'Andrew Jacob',
          photo: AndrewPic, 
          position: 'Brakes & Pedal Tray Lead',
          linkedin: "https://www.linkedin.com/in/andrew-jacob-mecheng/"
        },
        {
          name: 'Laaibah Iqbal',
          photo: LaaibahPic,  
          position: 'Business Lead',
          linkedin: "https://www.linkedin.com/in/laaibah-iqbal/"
        },
        {
          name: 'Sophia Webster',
          photo: SophiaPic,
          position: 'Chassis Lead',
          linkedin: "https://www.linkedin.com/in/sophia-webster02/"
        },
        {
          name: 'Mario Jovanovic',
          photo: MarioPic,
          position: 'Drivetrain Co-Lead',
          linkedin: "https://www.linkedin.com/in/mariojovanovicc/"
        },
        {
          name: 'Nicholas Warner',
          photo: NickPic,
          position: 'Drivetrain Co-Lead',
          linkedin: "https://www.linkedin.com/in/nicholastwarner/"
        },
        {
          name: 'Chrisha Joseph-Anton',
          photo: ChrishaPic,
          position: 'Ergonomics Lead',
          linkedin: "https://www.linkedin.com/in/chrisha-joseph-anton/"
        },
        {
          name: 'Manush Patel',
          photo: ManushPic,
          position: 'Firmware & Software Co-Lead',  
          linkedin: "https://www.linkedin.com/in/manushp/"
        },
        {
          name: 'Noah Jaye',
          photo: NoahPic,
          position: 'Firmware & Software Co-Lead',
          linkedin: "https://www.linkedin.com/in/noah-jaye-74870832a/"
        },
        {
          name: 'Francesca Buckley',
          photo: FrancescaPic,
          position: 'HV Electronics Lead',
          linkedin: "https://www.linkedin.com/in/francesca-buckley-8a8191298/"
        },
        {
          name: 'Aidan Kang',
          photo: AidanPic,
          position: 'LV Electronics Lead',
          linkedin: "https://www.linkedin.com/in/aidankang/"
        },
        {
          name: 'Cole Coenen',
          photo: ColePic,
          position: 'Manufacturing Lead',
          linkedin: "https://www.linkedin.com/in/cole-coenen-01a673342/"
        },
        {
          name: 'Mya Spoelstra',
          photo: MyaPic,
          position: 'Powertrain Electrical Co-Lead',
          linkedin: "https://www.linkedin.com/in/myaspoelstra/"
        },
        {
          name: 'Remy Robinson',
          photo: RemyPic,
          position: 'Powertrain Electrical Co-Lead',
          linkedin: "https://www.linkedin.com/in/remy-robinson/"
        },
        {
          name: 'Kevin Ngo',
          photo: KevinPic,
          position: 'Powertrain Mechanical Lead',
          linkedin: "https://www.linkedin.com/in/kevin-minh-ngo/"
        },
        {
          name: 'Mubashir Ansari',
          photo: MubashirPic,
          position: 'Suspension Co-Lead',
          linkedin: "https://www.linkedin.com/in/mubashirza/"
        },
        {
          name: 'Spencer Dickinson',
          photo: SpencerPic,
          position: 'Suspension Co-Lead',
          linkedin: "https://www.linkedin.com/in/spencer-ap-dickinson/"
        },
        {
          name: 'Jinwook Park',
          photo: JinPic,
          position: 'Vehicle Dynamics Co-Lead',
          linkedin: "https://www.linkedin.com/in/jinwook-park0817/"
        },
        {
          name: 'Quin Hutton',
          photo: QuinPic,
          position: 'Vehicle Dynamics Co-Lead',
          linkedin: "https://www.linkedin.com/in/quin-hutton/"
        },
        {
          name: "Bosco Tsang",
          photo: BoscoPic,
          position: "Wire Harness Lead",
          linkedin: "https://www.linkedin.com/in/bosco-tsang-93416a214/"
        }
      ]
    }
  }


  render() {
    return ( 
      <div className = "" >
        <h1 className = "team-showcase-text" > TEAM LEADERSHIP </h1> 
        <div className = "team-members-container" >
          {
            this.state.members.map(member => ( 
              <div className = "team-member-container" >
                <div className = "team-member-image-container" >
                  <img className = "team-member-image" src = {member.photo} alt = "" />
                </div> 
                <div className = "team-member-text-container" >
                  <h1 className = "team-member-name" > {member.name} </h1> 
                  <h2 className = "team-member-position" > {member.position} </h2> 
                  <a href = {member.linkedin} style = {{textDecoration: 'none'}} target = "_blank" rel = "noopener noreferrer" >
                    <div className = "team-member-linkedin-button" >
                      <h1 className = "team-member-linkedin-name" > in </h1> 
                    </div> 
                  </a> 
                </div> 
            </div>
            ))
          } 
        </div> 
      </div>
    )
  }
}

export default TeamMembers;
